import h2hWidgetMixin from '../h2h-widget-mixin';

export default {
  mixins: [h2hWidgetMixin],
  data() {
    return { activeSide: null };
  },
  methods: {
    sideStyle(side, index) {
      const share = this.tile.shares[index === 0 ? 0 : this.tile.shares.length - 1];
      const center = index === 0 ? share / 2 : 100 - share / 2;
      return {
        '--side-color': side.color,
        '--side-ink': side.ink,
        '--portrait-center': `${center}%`,
      };
    },
  },
};
